import React, { FC } from 'react';

import BasicPage from 'inruta-commons/lib/pages/BasicPage';
import {
  Box, makeStyles, createStyles,
} from '@material-ui/core';
import AppMenu from '../../components/AppMenu';

const useStyles = makeStyles(() => createStyles({
  appMenuBox: {
    display: 'inline-block',
    width: '20rem',
  },
  contentsBox: {
    display: 'inline-block',
    verticalAlign: 'top',
  },
}));

const Page: FC = (props) => {
  const classes = useStyles();

  return (
    <BasicPage>
      <Box className={classes.appMenuBox}>
        <AppMenu />
      </Box>
      <Box className={classes.contentsBox}>
        { props?.children }
      </Box>
    </BasicPage>
  );
};

export default Page;
